// import select2 from "select2";
import "jquery-custom-select";
// import "custom-select";

// var customSelect = require("custom-select/build/jquery.custom-select.min.js")
//     .default;

$("select").customSelect();
